package pwgs.ui.scenes.ensureloggedin

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(EnsureLoggedInSceneProps::class, EnsureLoggedInSceneModel::class)
interface EnsureLoggedIn {

    fun load()

}

@Serializable
class EnsureLoggedInSceneProps {

}

@Serializable
class EnsureLoggedInSceneModel(
    val isLoading: Boolean,
    val isLoggedIn: Boolean
) {

}